import { render, staticRenderFns } from "./GameAbout.vue?vue&type=template&id=eb86dc9c&scoped=true&"
import script from "./GameAbout.vue?vue&type=script&lang=js&"
export * from "./GameAbout.vue?vue&type=script&lang=js&"
import style0 from "./GameAbout.vue?vue&type=style&index=0&id=eb86dc9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb86dc9c",
  null
  
)

export default component.exports